import { forwardRef } from 'react';
import { Trans } from '@lingui/react/macro';
import { Button } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
export const ResponsiveButton = forwardRef((props, forwardedRef) => {
    const { onClick } = props;
    return (<Button type="button" ref={forwardedRef} size="xs" appearance="secondary" onClick={onClick}>
      <Falcon icon="layer-plus"/>
      <Trans comment="Create team button text">New team</Trans>
    </Button>);
});
